import { Link } from 'react-router-dom';
import { getNewDramas } from '@/mocks/dramas';

export default function LatestUpdates() {
  const newDramas = getNewDramas();

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-timer-flash-line text-xl text-primary-500"></i>
            </div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              最新更新
            </h2>
          </div>
          <Link
            to="/category/hanju"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {newDramas.map((drama) => (
            <Link
              key={drama.id}
              to={`/article/${drama.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3 bg-background-200">
                <img
                  src={drama.coverImage}
                  alt={drama.title}
                  title={`${drama.title} - ${drama.subtitle}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2">
                  <span className="inline-flex items-center px-2 py-0.5 bg-accent-500 text-background-50 text-[10px] font-semibold rounded-full whitespace-nowrap">
                    NEW
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3 pt-8">
                  <span className="text-background-50 text-xs whitespace-nowrap">{drama.updateInfo}</span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {drama.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {drama.cast.slice(0, 3).join(' / ')}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}